<template lang="pug">
    v-container
        h1 Summary
        v-data-table.my-10.elevation-1(:headers="headers" :items="items" :page.sync="page"  :items-per-page="itemsPerPage" hide-default-footer @page-count="pageCount = $event")
            template(v-slot:item.url="{item}")
                router-link(:to="item.url") {{item.url}}
        .text-center
            v-pagination(v-model="page" :length="pageCount")

</template>
<script>
export default {
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 30,
      headers: [
        {
          text: "類別",
          align: "start",
          sortable: true,
          value: "category"
        },
        {
          text: "名稱",
          align: "start",
          sortable: true,
          value: "name"
        },
        {
          text: "連結",
          align: "start",
          sortable: true,
          value: "url"
        }
      ],
      items: [
        { name: "登入", category: "登入註冊", url: "/login" },
        {
          name: "忘記密碼",
          category: "登入註冊",
          url: "/forgot-password"
        },
        {
          name: "重設密碼",
          category: "登入註冊",
          url: "/reset-password"
        },
        { name: "註冊", category: "登入註冊", url: "/signup" },
        {
          name: "填寫註冊資訊",
          category: "登入註冊",
          url: "/business-info"
        },
        { name: "客戶列表", category: "銷售", url: "/customers" },
        {
          name: "新增/修改客戶",
          category: "銷售",
          url: "/customers/new"
        },
        {
          name: "商品服務列表",
          category: "銷售",
          url: "/products"
        },
        {
          name: "新增/修改商品",
          category: "銷售",
          url: "/products/new"
        },
        {
          name: "請款單列表",
          category: "銷售",
          url: "/invoices"
        },
        {
          name: "新增/修改請款單",
          category: "銷售",
          url: "/invoices/new"
        },
        {
          name: "請款單內容",
          category: "銷售",
          url: "/invoices/1/view"
        },
        {
          name: "報價單列表",
          category: "銷售",
          url: "/estimates"
        },
        {
          name: "新增/修改報價單",
          category: "銷售",
          url: "/estimates/1"
        },
        {
          name: "預覽報價單",
          category: "銷售",
          url: "/estimates/1/preview"
        },
        {
          name: "預覽報價單-客戶",
          category: "銷售",
          url: "/estimates/1"
        },
        {
          name: "對帳單",
          category: "銷售",
          url: "/customer-statements"
        },
        { name: "帳單列表", category: "採購", url: "/purchases/bills" },
        {
          name: "新增/修改帳單",
          category: "採購",
          url: "/purchases/bills/1"
        },
        { name: "稅項管理", category: "設定", url: "/settings/taxes" }
      ]
    }
  }
}
</script>
